import { Component, signal } from '@angular/core';
import { ToastConfig, ToastService } from 'src/shared/services/toast.service';

@Component({
  selector: 'cert-toast-container',
  templateUrl: './toast-container.component.html',
  styles: ``,
  standalone: false,
})
export class ToastContainerComponent {
  toasts = signal<ToastConfig[]>([]);

  constructor(toastService: ToastService) {
    toastService.toasts$.subscribe({
      next: (x) => {
        this.toasts.set([...this.toasts(), x]);
      },
    });
  }
}
